<template lang="html">

  <section class="login">
    <div class="wrapper d-flex align-items-center auth login-full-bg h-100">
      <div class="row w-100">
        <div class="col-lg-6 mx-auto box-login">
          <div class="auth-form-dark text-left p-5">
            <div class="text-center mb-5">
              <img src="@/assets/images/consulta-ja-logo.svg" width="50%" alt="Consulta Já" />
            </div>
            <h2>Esqueceu sua senha?</h2>
            <h4 class="font-weight-light">Informe o seu e-mail de acesso ao Consulta Já para receber as instruções para redefinir sua senha</h4>
            <form class="pt-5" autocomplete="off">
                <form autocomplete="off" @submit.prevent>
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input type="email" v-model="email" class="form-control" id="email" @keyup.enter="forgotPassword">
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="mt-5">
                  <a class="btn btn-block btn-primary btn-lg font-weight-medium" @click="forgotPassword">Recuperar senha</a>
                </div>
                <div class="mt-3 text-center">
                  <router-link to="/login" class="login-link mt-3">Voltar para o login</router-link>
                </div>
              </form>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
export default {
  data () {
    return {
      leavingPage: false,
      isLoading: null,

      email: ''
    }
  },
  created: function () {
    if (this.api.isLogged()) {
      this.eventBus.$emit('IS_LOGGED', true);
      if (this.api.hasOnboarded()) {
        if (this.api.isSuspended()) {
          this.$router.push('/minha-assinatura').catch(() => {});
        }
        else {
          this.$router.push('/dashboard').catch(() => {});
        }
      }
      else {
        this.$router.push('/primeiros-passos').catch(() => {});
      }
    }
  },
  mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          return;
        }
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          this.isLoading.hide();
          this.isLoading = null;
        }
      }
    });
  },
  methods: {
    forgotPassword () {
      if(this.email == 'undefined' || this.email == '') {
        this.$swal('Ops...', 'E-mail inválido!', 'error');
        return false;
      }
      this.eventBus.$emit('IS_LOADING', true);
      this.api.forgotPassword({ email: this.email }).then(() => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.$swal('Uhull \\o/', 'Em breve você recebera em seu e-mail as instruções para redefinir sua senha!', 'success');
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        let response = err.response;
        let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';

        this.$swal('Ops...', message, 'error');

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error', err);
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.leavingPage = true;
    next();
  }
}
</script>

<style scoped lang="scss">
.login {
  height: 100vh;
  background-image: linear-gradient(to bottom right, #eaeaea , #cccccc);

  .login-full-bg {
    background: url(../assets/images/bg-login.jpg) center center;
  }

  .box-login {
    font-family: 'sf_pro_displaymedium';
    background-color: $bunting;
    color: #ffffff;
  }

  .login-link {
    color: #ffffff;
    font-size: 18px;
  }
}
</style>
